const $28c6f9c08ce99e30$var$MOBILE_NAV_MQ = window.matchMedia("(max-width: 75em)");
function $28c6f9c08ce99e30$export$461f6e96ec5e0362() {
    const menuBtn = document.getElementById("site-menu-btn");
    const nav = document.getElementById("site-nav");
    const headerRight = document.querySelector(".site-header__right");
    if (!menuBtn || !nav || !headerRight) return;
    let backdrop = document.querySelector(".site-menu-backdrop");
    if (!backdrop) {
        backdrop = document.createElement("div");
        backdrop.className = "site-menu-backdrop";
        backdrop.setAttribute("aria-hidden", "true");
        document.body.appendChild(backdrop);
        backdrop.addEventListener("click", ()=>setMenuOpen(false));
    }
    const setMenuOpen = (open)=>{
        nav.classList.toggle("is-open", open);
        menuBtn.classList.toggle("is-active", open);
        menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
        document.body.classList.toggle("site-menu-open", open);
        backdrop.classList.toggle("is-open", open);
    };
    const ensureDrawerChrome = ()=>{
        if (!nav.querySelector(".site-header__drawer-head")) {
            const head = document.createElement("div");
            head.className = "site-header__drawer-head";
            head.innerHTML = `
        <p class="site-header__drawer-title" id="nav-drawer-title">Menu</p>
        <button type="button" class="site-header__close" id="site-menu-close" aria-label="Close">
          <span class="site-header__close-icon" aria-hidden="true"></span>
        </button>`;
            nav.insertBefore(head, nav.firstChild);
            document.getElementById("site-menu-close")?.addEventListener("click", ()=>setMenuOpen(false));
        }
        let lang = headerRight.querySelector(".site-header__lang");
        if (!lang) lang = nav.querySelector(".site-header__drawer-foot .site-header__lang");
        if (lang && !nav.querySelector(".site-header__drawer-foot")) {
            const foot = document.createElement("div");
            foot.className = "site-header__drawer-foot";
            foot.appendChild(lang);
            nav.appendChild(foot);
        }
    };
    const syncNavPlacement = ()=>{
        if ($28c6f9c08ce99e30$var$MOBILE_NAV_MQ.matches) {
            ensureDrawerChrome();
            if (nav.parentElement !== document.body) document.body.appendChild(nav);
            nav.classList.add("is-drawer");
            return;
        }
        setMenuOpen(false);
        nav.classList.remove("is-drawer");
        const lang = nav.querySelector(".site-header__lang");
        if (lang && lang.parentElement !== headerRight) headerRight.appendChild(lang);
        if (nav.parentElement !== headerRight) headerRight.insertBefore(nav, menuBtn);
    };
    menuBtn.addEventListener("click", ()=>setMenuOpen(!nav.classList.contains("is-open")));
    nav.querySelectorAll("a").forEach((a)=>a.addEventListener("click", ()=>setMenuOpen(false)));
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && nav.classList.contains("is-open")) setMenuOpen(false);
    });
    $28c6f9c08ce99e30$var$MOBILE_NAV_MQ.addEventListener("change", syncNavPlacement);
    document.addEventListener("napire-lang-updated", ()=>{
        const n = window.dafaultLanguage?.nav;
        const lang = document.documentElement.lang === "en" ? "en" : "ja";
        if (!n) return;
        const t = (o)=>o && o[lang] || "";
        const title = document.getElementById("nav-drawer-title");
        if (title) title.textContent = t(n.drawerTitle);
        const close = document.getElementById("site-menu-close");
        if (close) close.setAttribute("aria-label", t(n.close));
        menuBtn.setAttribute("aria-label", t(n.menuOpen));
    });
    syncNavPlacement();
}
var $28c6f9c08ce99e30$export$2e2bcd8739ae039 = $28c6f9c08ce99e30$export$461f6e96ec5e0362;


function $bffbda477dd8aeb3$export$2e2bcd8739ae039() {
    (0, $28c6f9c08ce99e30$export$2e2bcd8739ae039)();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((e)=>{
            if (e.isIntersecting) {
                e.target.classList.add("is-visible");
                observer.unobserve(e.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: "0px 0px -5% 0px"
    });
    const observeReveals = ()=>{
        document.querySelectorAll(".reveal:not(.is-visible)").forEach((el)=>{
            const rect = el.getBoundingClientRect();
            const inView = rect.top < window.innerHeight + 80 && rect.bottom > -80;
            if (inView) {
                el.classList.add("is-visible");
                return;
            }
            observer.observe(el);
        });
    };
    observeReveals();
    document.addEventListener("napire-lang-updated", observeReveals);
    const revealMutationObserver = new MutationObserver((mutations)=>{
        const hasAddedReveal = mutations.some((mutation)=>Array.from(mutation.addedNodes).some((node)=>node.nodeType === Node.ELEMENT_NODE && (node.matches?.(".reveal") || node.querySelector?.(".reveal"))));
        if (hasAddedReveal) observeReveals();
    });
    revealMutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    const heroVideo = document.querySelector(".hero-cinematic__video");
    if (heroVideo) {
        const playHeroVideo = ()=>{
            heroVideo.play().catch(()=>{});
        };
        playHeroVideo();
        document.addEventListener("visibilitychange", ()=>{
            if (!document.hidden) playHeroVideo();
        });
    }
}


(0, $bffbda477dd8aeb3$export$2e2bcd8739ae039)();


//# sourceMappingURL=corporate-site.0ef7e124.js.map
